import styled from 'styled-components'
import { colors, media, fonts } from 'shared/lib'

const Container = styled.div`
  line-height: 18px;
  ${fonts.BODY_TEXT}
  ${media.large`
    display: flex;
    justify-content: space-between;
  `}
`

const AddressMain = styled.address`
  color: ${colors.FC2_BLACK};
  margin-bottom: 15px;
  font-style: normal;
  ${media.large`
    width: 50%;
    margin-bottom: 0;
  `}
`

const AddressSecondaryInformation = styled.div`
  ${fonts.BODY_TEXT}
  ${media.large`
    width: 50%;
  `}
`

const AddressLine = styled.p`
  margin: 0 0 5px;
`

type Phone = {
  display: string
}

type AddressSummaryDisplayProps = {
  name: string
  address1: string
  address2?: string
  city: string
  state: string
  postalCode: string
  country: string
  phone?: Phone | string
  qaAttr?: string
  className?: string
}

const AddressSummaryDisplay = (props: AddressSummaryDisplayProps) => {
  const {
    name,
    address1,
    address2,
    city,
    state,
    postalCode,
    country,
    phone,
    qaAttr,
    className,
  } = props
  const phoneNumber = (typeof phone === 'string' ? phone : phone?.display) || ''
  return (
    <Container className={className}>
      <AddressMain data-qa={`${qaAttr}MainContent`}>
        <AddressLine>{name}</AddressLine>
        <AddressLine>{address1}</AddressLine>
        <AddressLine>{address2}</AddressLine>
        <AddressLine>
          {city}, {state}, {postalCode}
        </AddressLine>
      </AddressMain>
      <AddressSecondaryInformation data-qa={`${qaAttr}SecondaryContent`}>
        <AddressLine>{country}</AddressLine>
        <AddressLine>{phoneNumber}</AddressLine>
      </AddressSecondaryInformation>
    </Container>
  )
}

export default AddressSummaryDisplay
